import React, { useEffect, useState, Suspense } from 'react';
import axios from 'axios';
import Routes from './routes';
import config from './config';
import { ToastContainer, toast } from 'react-toastify';
import { Toaster } from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { requestPermission } from "./Notification";
import './assets/scss/themes.scss';
import './assets/scss/custom/pages/Loader.scss';
import fakeBackend from './helpers/fake-backend';

// Firebase
import { messaging } from "./helpers/firebaseInitial";
import { getToken, onMessage } from "./helpers/firebaseInitial";
import { registerServiceWorker } from './firebase-sw-registration';
import Loader from './components/Loader';

// Start fake backend
fakeBackend();

// Axios base URL
// axios.defaults.baseURL = "https://staging.webmobrildemo.com/wmconnectbackend/";
axios.defaults.baseURL = process.env.REACT_APP_API_URL_backendUrl;

function App() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [notification, setNotification] = useState(null);

  // Redux layout selector
  const selectLayoutProperties = createSelector(
    (state) => state.Layout,
    (layout) => ({
      layoutMode: layout.layoutMode,
    })
  );

  const { layoutMode } = useSelector(selectLayoutProperties);

  // 🔌 Internet connectivity detection
  useEffect(() => {
    const handleOffline = () => {
      setIsOffline(true);
      // toast.error("You are offline", { position: "bottom-left" });
    };

    const handleOnline = () => {
      setIsOffline(false);
      // toast.success("You are back online", { position: "bottom-left" });
    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  // 🔄 Layout mode persistence
  useEffect(() => {
    layoutMode && localStorage.setItem("layoutMode", layoutMode);
  }, [layoutMode]);

  // 🔔 Firebase notifications
  useEffect(() => {
    requestPermission();
    // listenForMessages(); // Disabled - notifications handled in firebaseInitial.jsx
  }, []);

  return (
    <>
      {/* 🔒 Fullscreen overlay when offline */}
      {isOffline && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.8)',
          color: '#fff',
          zIndex: 9999,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '20px',
          textAlign: 'center'
        }}>
          <p>⚠️ You are offline.</p>
          <p>Please check your internet connection.</p>
        </div>
      )}

      <ToastContainer />
      {/* <Loader /> */}
      <Suspense fallback={<Loader />}>
        <Routes />
      </Suspense>
      <Toaster position="top-right" />
    </>
  );
}

export default App;
